import { mainButton } from '@tma.js/sdk-react'
import { useEffect } from 'react'
import { useLatest } from '@/shared/lib'

export type MainButtonConfig = {
  text: string
  onClick: () => void
  isVisible?: boolean
  isEnabled?: boolean
  /** Лоадер внутри кнопки — на время мутации. */
  isLoading?: boolean
}

/**
 * Главная кнопка экрана — нативная, её рисует Telegram. Одна на экран: два
 * «главных» действия значат, что экран спроектирован неверно.
 *
 * `null` — у экрана главной кнопки нет. Появление и скрытие анимирует сам
 * Telegram, своей кнопкой это не дублируется.
 */
export const useMainButton = (config: MainButtonConfig | null): void => {
  const onClick = useLatest(config?.onClick)
  const text = config?.text ?? ''
  const isVisible = config !== null && (config.isVisible ?? true) && text !== ''
  const isEnabled = config?.isEnabled ?? true
  const isLoading = config?.isLoading ?? false

  useEffect(() => {
    mainButton.setParams.ifAvailable(
      isVisible ? { text, isVisible, isEnabled, isLoaderVisible: isLoading } : { isVisible: false, isLoaderVisible: false },
    )
  }, [text, isVisible, isEnabled, isLoading])

  useEffect(() => {
    const subscription = mainButton.onClick.ifAvailable(() => onClick.current?.())

    return () => {
      if (subscription.ok) {
        subscription.data()
      }

      mainButton.setParams.ifAvailable({ isVisible: false, isLoaderVisible: false })
    }
  }, [onClick])
}
